import { z } from "zod";

export const rankingDecisionSchema = z.discriminatedUnion("status", [
    z.object({ status: z.literal("inactive") }).strict(),
    z.object({ status: z.literal("missing_identity") }).strict(),
    z.object({ status: z.literal("qa") }).strict(),
    z.object({ status: z.literal("noneligible") }).strict(),
    z
        .object({
            status: z.literal("randomized"),
            profileId: z.string().min(1),
            arm: z.enum(["control", "treatment"]),
            cardArm: z.enum(["control", "treatment"]),
            assignmentVersion: z.literal("ranking-sha256-v1"),
            cardAssignmentVersion: z.literal("legacy-fnv-v1"),
            rankingExperimentName: z.literal("search-ranking-pool-v1"),
            rankingExperimentVersion: z.literal("search-ranking-pool-v1"),
            cardExperimentName: z.literal("photo-first-cards"),
            cardExperimentVersion: z.literal("photo-first-cards-v1"),
        })
        .strict(),
]);

export type RankingDecision = z.infer<typeof rankingDecisionSchema>;
